/**
 * Mobile menu: faster link reveal + no 500ms delay when returning from sub-panels.
 * Prestige staggers each <li> by 100ms when stagger_menu_apparition is enabled (theme default).
 */
(function () {
  function patchHeaderSidebar() {
    const sidebar = document.getElementById('sidebar-menu');
    if (!sidebar || sidebar.__vinylSidebarPatched) {
      return;
    }

    if (typeof sidebar.revealItems !== 'function') {
      return;
    }

    sidebar.__vinylSidebarPatched = true;
    const originalReveal = sidebar.revealItems.bind(sidebar);

    sidebar.revealItems = function (withDelay) {
      const settings = window.themeVariables?.settings;
      const hadStagger = settings?.staggerMenuApparition;

      if (settings) {
        settings.staggerMenuApparition = false;
      }

      return originalReveal(false);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchHeaderSidebar);
  } else {
    patchHeaderSidebar();
  }

  document.addEventListener('shopify:section:load', patchHeaderSidebar);
  customElements.whenDefined('header-sidebar').then(patchHeaderSidebar);
})();
